// issue 109：把任意语言代码解析成 locales/ 下实际存在的目录。
// 语言检测器会把浏览器语言原样缓存（如 `en`、`zh`），而 locales/ 只有 `en-US` / `zh-CN` 这类带地区的目录；
// 解析不了时主语言和回退语言（同一个值）都加载失败 → 整套翻译缺失，设置页露出 `settings.*` 原始键名。

// 有多个地区变体的短代码，默认落到哪个
const DEFAULT_VARIANT: Record<string, string> = {
	en: 'en-US',
	zh: 'zh-CN',
	fr: 'fr-FR',
	pt: 'pt-BR',
	uz: 'uz-Latn-UZ'
};
const TRADITIONAL_CHINESE = /^zh[-_](hant|tw|hk|mo)\b/i;

export const FALLBACK_LANGUAGE = 'en-US';

export function resolveBundledLanguage(language: string | null | undefined, available: string[]): string {
	const raw = String(language ?? '').trim();
	if (!raw) return FALLBACK_LANGUAGE;
	if (available.includes(raw)) return raw;
	const lower = raw.toLowerCase().replace(/_/g, '-');
	const exact = available.find((code) => code.toLowerCase() === lower);
	if (exact) return exact;
	if (TRADITIONAL_CHINESE.test(lower) && available.includes('zh-TW')) return 'zh-TW';
	const base = lower.split('-')[0];
	const preferred = DEFAULT_VARIANT[base];
	if (preferred && available.includes(preferred)) return preferred;
	const sameBase = available.find((code) => code.toLowerCase().split('-')[0] === base);
	return sameBase ?? FALLBACK_LANGUAGE;
}
